<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="属性名称">
                <el-input v-model="queryForm.kvName" size="small" style="width: 180px" placeholder="请输入属性名称"></el-input>
            </el-form-item>
            <el-form-item label="所属分类">
                <el-select v-model="queryForm.categoryId" placeholder="请选择" clearable size="small">
                    <el-tree node-key="id" :default-expanded-keys="expands" :data="categoryListist" :props="treeProps">
                        <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                            <el-option :label="node.label" :value="data.id"> </el-option>
                        </div>
                    </el-tree>
                </el-select>
            </el-form-item>
            <el-form-item label="所属品牌">
                <GridSelect
                    style="width: 200px"
                    title="选择品牌"
                    labelName="brandName"
                    labelValue="id"
                    :value="queryForm.brandId"
                    :limit="1"
                    size="small"
                    placeholder="请选择品牌"
                    @getValue="getValue"
                    :columns="BRAND_code"
                    :searchs="BRAND_search"
                    dataListUrl="/shop/productbrand/findList"
                    entityBeanName="shopBrand"
                    queryEntityUrl="/shop/productbrand/get"
                >
                </GridSelect>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getattributeList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetQueryForm()">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopProduct">新建</el-button>
                    <!-- <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopProduct(null)"
                        >修改</el-button
                    > -->
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopProduct(null)"
                        >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <!-- <span title="导出数据" class="icon-box" @click="exportShopProductList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span> -->
                    <span class="icon-box" @click="refreshShopProductList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="attributeList" row-key="id" size="small" height="100%" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" width="50"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="left" prop="spuNameKv" label="属性名" width="150">
                    <template slot-scope="scope">
                        <div style="text-align: left">{{ scope.row.nameKv.kvName }}</div>
                    </template>
                </el-table-column>

                <el-table-column :show-overflow-tooltip="true" align="left" prop="category" label="分类" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.category != null">{{ scope.row.category.categoryName }}</div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="left" prop="category" label="品牌" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.brand != null">{{ scope.row.brand.brandName }}</div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="valueType" label="值类型" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.valueType == 1">选择</div>
                        <div v-else>输入</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="isRequired" label="是否必填" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isRequired == 1">是</div>
                        <div v-else>否</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="left" prop="valueKvList" label="属性值" width="250">
                    <template slot-scope="scope">
                        <div v-if="scope.row.valueKvList != null">
                            <span v-for="item of scope.row.valueKvList">{{ item.kvName }},</span>
                        </div>
                        <span v-else>--</span>
                    </template>
                </el-table-column>

                <el-table-column fixed="right" align="center" label="操作" width="250">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopProduct(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopProduct(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopProduct(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="pageNum"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>

            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="shopProductStates[attributeState]" :visible.sync="showDialog" width="40%" @close="closeDialog">
                <div class="add">
                    <el-form :model="attributeMation" ref="attributeForm" :rules="rules" label-width="80px" :inline="true" size="small">
                        <el-form-item label="属性名称" prop="nameKvName">
                            <el-input size="small" v-model="attributeMation.nameKvName" :disabled="attributeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="所属分类" prop="categoryId">
                            <el-select
                                v-model="attributeMation.categoryId"
                                placeholder="请选择"
                                clearable
                                size="small"
                                :disabled="attributeState == 'check'"
                            >
                                <el-tree node-key="id" :default-expanded-keys="expands" :data="categoryListist" :props="treeProps">
                                    <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                        <el-option :label="node.label" :value="data.id"> </el-option>
                                    </div>
                                </el-tree>
                            </el-select>
                            <!-- <el-select size="small" v-model="attributeMation.categoryId" :disabled="attributeState == 'check'">
                                <el-option v-for="item in categoryListist" :key="item.id" :label="item.categoryName" :value="item.id">
                                </el-option>
                            </el-select> -->
                            <!-- <el-input size="small" v-model="attributeMation.categoryName" :disabled="attributeState == 'check'"></el-input> -->
                        </el-form-item>
                        <el-form-item label="所属品牌" prop="brandId">
                            <GridSelect
                                style="width: 200px"
                                title="选择品牌"
                                labelName="brandName"
                                labelValue="id"
                                :value="attributeMation.brandId"
                                :limit="1"
                                :stateDisabled="attributeState == 'check'"
                                size="small"
                                placeholder="请选择品牌"
                                @getValue="getValue2"
                                :columns="BRAND_code"
                                :searchs="BRAND_search"
                                dataListUrl="/shop/productbrand/findList"
                                entityBeanName="shopBrand"
                                queryEntityUrl="/shop/productbrand/get"
                            >
                            </GridSelect>
                            <!-- <el-input size="small" v-model="attributeMation.brandName" :disabled="attributeState == 'check'"></el-input> -->
                        </el-form-item>

                        <el-form-item label="值类型" prop="valueType">
                            <el-select size="small" v-model="attributeMation.valueType" :disabled="attributeState == 'check'">
                                <el-option v-for="item in showData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否必填" prop="isRequired">
                            <el-select size="small" v-model="attributeMation.isRequired" :disabled="attributeState == 'check'">
                                <el-option v-for="item in attributeOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="AttributeValue" v-if="inputDisable">
                        <div class="shu">属性值</div>
                        <div class="right">
                            <div class="valueKv" v-for="item of attributeMation.valueKvNameList">
                                {{ item
                                }}<i v-if="attributeState != 'check'" class="el-icon-close close" @click="deleteParameter(item)"></i>
                            </div>

                            <div>
                                <el-input
                                    v-if="attributeState != 'check'"
                                    v-model="parameter"
                                    size="small"
                                    style="width: 100px; margin-right: 10px"
                                    :disabled="attributeState == 'check'"
                                ></el-input>
                                <el-button type="primary" v-if="attributeState != 'check'" size="small" @click="addParameter"
                                    >添加属性值</el-button
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="shopProductState != 'check'">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import WangEditor from '@/components/common/wangeditor';
import GridSelect from '@/components/gridselect/brand.vue';
import { BRAND, BRAND_SEARCH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        WangEditor,
        GridSelect
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopProductList();
                this.getShopProductList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopProductList();
                this.getShopProductList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            BRAND_code: BRAND,
            BRAND_search: BRAND_SEARCH,
            queryForm: {
                categoryId: '',
                kvName: '',
                brandId: ''
            },
            attributeMation: {
                nameKvName: '',
                categoryId: '',
                brandId: null,
                valueType: '',
                isRequired: '',
                valueKvNameList: []
            },
            rules: {
                nameKvName: [{ required: true, message: '所属名称不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '分类不能为空', trigger: 'blur' }],
                valueType: [{ required: true, message: '值类型不能为空', trigger: 'blur' }],
                isRequired: [{ required: true, message: '不能为空', trigger: 'blur' }]
            },
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            attributeState: '',
            attributeList: [],
            attributeOptions: [
                {
                    value: 1,
                    label: '是'
                },
                {
                    value: 0,
                    label: '否'
                }
            ],

            showData: [
                {
                    value: 1,
                    label: '选择'
                },
                {
                    value: 2,
                    label: '输入'
                }
            ],
            parameter: '',
            brandList: [],
            categoryListist: [],

            dialogImageUrl: '', //
            dialogVisible: false,
            disabled: false,
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            pageNum: 1,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopProductState: 'add',
            expands: [], //展开id
            shopProductStates: {
                add: '新建属性',
                check: '查看属性',
                edit: '修改属性'
            },

            multipleSelection: [],

            btnLoading: false,

            list: '',
            header: {
                token: localStorage.getItem('token')
            },
            auditStatus: [],
            inputDisable: true,
            stateDisabled: false
        };
    },
    watch: {
        'attributeMation.valueType': {
            handler(newVal, oldVal) {
                console.log(newVal, oldVal);
                if (newVal == 2) {
                    this.inputDisable = false;
                } else {
                    this.inputDisable = true;
                }
                // if (newVal != oldVal) {
                //     this.ClassificationChange();
                // }
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        this.attributeFindlist();
        this.productbrand();
        this.findAllAsTree();
    },
    onload() {
        console.log(localStorage.getItem('token'));
    },
    methods: {
        attributeFindlist() {
            get('/shop/attribute/findList', { ...this.queryForm, pageNum: this.pageNum, pageSize: this.pageSize }).then((res) => {
                this.attributeList = res.page.list;
                this.totalNum = res.page.total;
            });
        },
        productbrand() {
            get('/shop/productbrand/findAll').then((res) => {
                this.brandList = res.list;
                console.log(this.brandList);
            });
        },

        findAllAsTree() {
            get('/shop/productcategory/findAllAsTree').then((res) => {
                this.categoryListist = res.treeData;
                res.treeData.forEach((element) => {
                    this.expands.push(element.id);
                });
            });
        },

        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopProductList() {
            this.pageSize = 10;
            this.pageNum = 1;
            this.attributeList = [];
        },
        closeDialog() {
            this.attributeMation = {
                nameKvName: '',
                categoryId: '',
                brandId: '',
                valueType: '',
                isRequired: '',
                valueKvNameList: []
            };
            // this.$refs.contentEditor.init('');
            this.showDialog = false;
        },

        submitForm() {
            if (this.attributeState == 'add') {
                this.$refs.attributeForm.validate((valid) => {
                    if (valid) {
                        console.log(this.attributeMation);
                        post(`/shop/attribute/add`, { ...this.attributeMation }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductList();
                                this.attributeFindlist();
                                this.closeDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.attributeState == 'edit') {
                this.$refs.attributeForm.validate((valid) => {
                    if (valid) {
                        const attribute = {
                            ...this.attributeMation,
                            id: this.currentShopProductId
                        };

                        console.log(this.attributeMation);
                        post(`/shop/attribute/edit`, { ...attribute }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductList();
                                this.attributeFindlist();
                                this.closeDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopProduct() {
            this.showDialog = true;
            this.attributeState = 'add';
        },
        checkShopProduct(shopProductId) {
            this.stateDisabled = true;
            console.log(shopProductId);
            this.currentShopProductId = shopProductId;
            this.getShopProductById();
            this.showDialog = true;
            this.attributeState = 'check';
        },
        editShopProduct(shopProductId) {
            console.log(133232);
            if (shopProductId) {
                this.currentShopProductId = shopProductId;
                this.getShopProductById();
            }

            this.showDialog = true;
            this.attributeState = 'edit';
        },
        deleteShopProduct(shopProductId) {
            let ids = '';
            if (shopProductId) {
                ids = shopProductId;
            } else {
                ids = this.multipleSelection.map((shopProduct) => shopProduct.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/attribute/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductList();
                            this.attributeFindlist();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopProductList() {
            this.resetShopProductList();
            this.attributeFindlist();
        },

        getShopProductById() {
            this.loading = true;
            this.shopProduct = {};

            this.list = '';
            get(`/shop/attribute/get`, { id: this.currentShopProductId }).then((res) => {
                // this.$refs.contentEditor.init('');
                if (res.success) {
                    // this.$refs.contentEditor.init(this.shopProduct.productContent);
                    this.loading = false;
                    this.attributeMation.valueType = res.attribute.valueType;
                    this.attributeMation.isRequired = res.attribute.isRequired;
                    this.attributeMation.nameKvName = res.attribute.nameKv.kvName;
                    this.attributeMation.categoryId = res.attribute.categoryId;
                    this.attributeMation.brandId = res.attribute.brandId;

                    if (res.attribute.valueKvList != null) {
                        for (let item of res.attribute.valueKvList) {
                            console.log(item);
                            this.attributeMation.valueKvNameList.push(item.kvName);
                        }
                    } else {
                        this.attributeMation.valueKvNameList = [];
                    }

                    console.log(this.attributeMation);
                }
            });
        },
        /**
         * 导出出岗位信息
         */
        exportShopProductList() {
            this.btnLoading = true;
            exprotExcel(`/shop/product/export`, this.shopProduct, this.btnLoading);
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/product/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/product/importData`, formData);
            this.refreshShopProductList();
        },

        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.pageNum = page;
            this.attributeFindlist();
        },
        sizeChange(size) {
            console.log(size);
            this.pageSize = size;
            this.attributeFindlist();
        },
        resetQueryForm() {
            this.queryForm = {
                categoryId: '',
                kvName: '',
                brandId: ''
            };
            this.attributeFindlist();
        },
        addParameter() {
            if (this.parameter == '') {
                this.$message({
                    message: '不能添加空内容',
                    type: 'error',
                    duration: 2000
                });
                return;
            }
            let falg = true;

            for (let item of this.attributeMation.valueKvNameList) {
                // console.log(item);
                // console.log(typeof item);

                // console.log(this.parameter);
                // console.log(typeof this.parameter);

                if (item === this.parameter) {
                    falg = false;
                    break;
                }
            }
            if (falg) {
                this.attributeMation.valueKvNameList.push(this.parameter);
            } else {
                this.$message({
                    message: '不能添加相同类容',
                    type: 'success',
                    duration: 2000
                });
            }
            this.parameter = '';
        },
        deleteParameter(item) {
            console.log(item);
            for (let i = 0; i < this.attributeMation.valueKvNameList.length; i++) {
                if (this.attributeMation.valueKvNameList[i] == item) {
                    this.attributeMation.valueKvNameList.splice(i, 1);
                }
            }
        },
        getattributeList() {
            this.attributeFindlist();
        },
        getValue(value) {
            this.categoryListist.brandId = value;
            this.queryForm.brandId = value;
        },
        getValue2(value) {
            this.categoryListist.brandId = value;
            this.attributeMation.brandId = value;
        }
    }
};
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
}
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
::v-deep .add .el-input {
    width: 200px;
}
::v-deep .add .el-select {
    width: 200px;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.disUoloadSty .el-upload--picture-card {
    display: none;
}
.classInput {
    width: 200px;
}
.AttributeValue {
    width: 100%;
    display: flex;
    // justify-content: center;
    // align-items: center;
    .shu {
        width: 80px;
        text-align: right;
        margin-right: 12px;
    }
    .right {
        display: flex;
        // align-items: center;
        width: 100%;
        flex-wrap: wrap;
    }
}
.valueKv {
    // width: 100px;
    padding: 0 10px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #ccc;
    // border-radius: 10px;
    margin: 0 10px 10px 0;
    position: relative;
}
.close {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-color: #409eff;
    color: #fff;
    border-radius: 100%;
}
</style>
